import {fetch} from './fetch'

export const fetchGetActivity = (id) => fetch('POST', '/api/activity/getActivity', {

    id

})

export const fetchGetChannel = (id) => fetch('GET', '/api/channel/getChannelsByActId', {
    id
})

export const fetchGetCoupon = (countryCode, mobile, releaseId, couponStoreType, actId) => fetch('POST', '/api/coupon/getCoupon', {

    countryCode, mobile, releaseId, couponStoreType, actId

})
 
// 领取sku码 
export const fetchGetSkuCoupon = (countryCode, mobile, sku, actId) => fetch('POST', '/api/coupon/getSkuCoupon', {

    countryCode, mobile, sku, actId

})

// 存储用户信息
export const fetchAddJegoUser = (countryCode, mobile, jegoUserId, countryName, token) => fetch('POST', '/api/jegoUser/addJegoUser', {

    countryCode, mobile, jegoUserId, countryName, token

})
export const fetchMobieleNcryption = (mobile) => fetch('GET', '/api/jegoUser/mobileEncryption', {
    mobile
})




// WEBPACK FOOTER //
// ./src/common/js/succestechApi.js